import {ReactNode} from 'react'
import s from './styles.module.scss'
import CookiesConsent from '@/components/CookiesConsent'

interface MainLayoutProps {
  className?: string
  children: ReactNode
  /**
   * Set it to false to remove the 'mds' class from the container. Defaults to true.
   */
  mdsContainer?: boolean
}

const MainLayout = ({
  children,
  className,
  mdsContainer = true,
}: MainLayoutProps) => {
  const getClassNameString = () => {
    const mdsContainerString = mdsContainer ? 'mds' : ''
    const classNameString = className ?? ''
    return `${s.mainContainer} ${classNameString} ${mdsContainerString}`
  }

  return (
    <main className={getClassNameString()}>
      <CookiesConsent />
      {children}
    </main>
  )
}

export default MainLayout
